import React, { useState, useEffect } from 'react';
import { Sling as Hamburger } from 'hamburger-react';
import { Link } from 'react-router-dom';
import styles from "./header.module.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [searchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isScrollingUp = prevScrollPos > currentScrollPos;

      setVisible(isScrollingUp || currentScrollPos < 50);
      setScrolled(currentScrollPos > 50);
      setPrevScrollPos(currentScrollPos);

      // Close the hamburger menu when scrolling on mobile
      if (isOpen) {
        setIsOpen(false); // Close menu
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isOpen, prevScrollPos]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Disable scrolling when the mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  // New function to handle navigation click
  const handleNavClick = () => {
    setIsOpen(false); // Close the hamburger menu
    // Scroll to top when navigating to a new page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Header section */}
      <header
        className={`${styles.header} ${scrolled ? styles.scrolled : ''} ${visible ? styles.visible : styles.hidden}`}
      >
        <div className={styles.navDis}>
          <div className={styles.leftSide}>
            <Link to="/" className={styles.logo}>
              <img src='/assets/images/logoo.png' alt="Logo" />
            </Link>
          </div>
          <ul className={styles.desktopMenu}>
            <li><Link to="/car-branding">Brendimi i Makinave</Link></li>
            <li><Link to="/billboard">Billboard</Link></li>
            <li><Link to="/custom-materials">Materiale të Personalizuara</Link></li>
            <li><Link to="/3d-branding">Brendimi 3D</Link></li>
            <li><Link to="/contact" className={styles.contactBtn}>Kontakti</Link></li>
          </ul>
          <div className={styles.hamburger}>
            <Hamburger toggled={isOpen} toggle={setIsOpen} />
          </div>
        </div>
      </header>

      {/* Navigation outside the header for mobile view */}
      <nav className={`${styles.nav} ${isOpen ? styles.open : ''}`}>
        <ul>
          <li><Link to="/car-branding" onClick={handleNavClick}>Brendimi i Makinave</Link></li>
          <li><Link to="/billboard" onClick={handleNavClick}>Billboard</Link></li>
          <li><Link to="/custom-materials" onClick={handleNavClick}>Materiale të Personalizuara</Link></li>
          <li><Link to="/3d-branding" onClick={handleNavClick}>Brendimi 3D</Link></li>
          <li><Link to="/contact" onClick={handleNavClick} className={styles.contactBtn}>Kontakti</Link></li>
        </ul>
        {searchVisible && (
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        )}
      </nav>
    </>
  );
};

export default Header;
